import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { TranslateService } from '@ngx-translate/core';

import { ActionMode, PageAction } from './models/common';
import { DrawDetailHeaderModel } from './models/draw-detail-header-model';

@Component({
  selector: 'app-draw-detail-container',
  templateUrl: './draw-detail-container.component.html',
  styleUrls: ['./draw-detail-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DrawDetailContainerComponent implements OnInit {

  actionMode = ActionMode;
  @Input()
  public mode: ActionMode = ActionMode.view;

  @Input()
  enablePictureEdit: boolean = true;


  @Input()
  enableTitle: boolean = false;

  @Input()
  title: string;


  @Input()
  form: UntypedFormGroup;

  @Output()
  public pageAction: EventEmitter<PageAction> = new EventEmitter<PageAction>();

  @Input()
  public header: DrawDetailHeaderModel = new DrawDetailHeaderModel();

  @Input()
  public customHeaderAction: boolean = false;

  @Input()
  public redirectWithClose: boolean = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private translateService: TranslateService,
    public confirmation: FuseConfirmationService,
    private router: Router,
    private route: ActivatedRoute) {
    this.form = this.formBuilder.group({});
  }

  ngOnInit(): void {
  }

  showEditMode(): void {
    this.mode = ActionMode.edit;
  }

  deleteClicked(): void {

    const title = this.translateService.instant('SystemAdmin.Components.DrawDetailContainer.DeleteConfirmation.Title');
    const message = this.translateService.instant('SystemAdmin.Components.DrawDetailContainer.DeleteConfirmation.Message');
    const confirmText = this.translateService.instant('SystemAdmin.Components.DrawDetailContainer.DeleteConfirmation.Confirm');
    const cancelText = this.translateService.instant('SystemAdmin.Components.DrawDetailContainer.DeleteConfirmation.Cancel');
    const dialogRef = this.confirmation.open({
      "title": title,
      "message": message,
      "icon": {
        "show": true,
        "name": "fal:circle-exclamation",
        "color": "warn"
      },
      "actions": {
        "confirm": {
          "show": true,
          "label": confirmText,
          "color": "warn"
        },
        "cancel": {
          "show": true,
          "label": cancelText
        }
      },
      "dismissible": true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirmed') {
        this.pageAction.emit(PageAction.delete);
      }
    });
  }

  editClicked(): void {
    this.pageAction.emit(PageAction.edit);
  }

  cancelClicked(): void {
    this.pageAction.emit(PageAction.cancel);

    if (this.mode === ActionMode.edit)
      this.mode = ActionMode.view;
  }

  saveClicked(): void {
    this.pageAction.emit(PageAction.save);
  }

  imageChanged(imageData: {imageUrl: string, imageId?: string}) {
    this.header.profileImageUrl = imageData.imageUrl;
    this.header.profileImageId = imageData.imageId;
  }

  closeClicked(): void {
    this.pageAction.emit(PageAction.cancel);
    if (this.redirectWithClose) {
      this.router.navigate(['..'], { relativeTo: this.route });
    }
  }
}
